import React, { useState } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import API_BASE_URL from '../../ApiConfig/ApiConfig';
import LoadingScreen from '../Loading_Screen/LoadingScreen';
import Cookies from 'js-cookie';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faUser, faLock, faEye, faEyeSlash } from '@fortawesome/free-solid-svg-icons';
import nemessage from '../../../Assets/New Message Received.gif';
const AdminLogin = () => {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [forgotPasswordMessage, setForgotPasswordMessage] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [loading, setLoading] = useState(false);
  const [showModal, setShowModal] = useState(false); // Modal visibility state
  const navigate = useNavigate();

  const togglePasswordVisibility = () => {
    setShowPassword((prevState) => !prevState);
  };

  const handleLogin = async (event) => {
    event.preventDefault();
    setLoading(true);
  
    try {
      const response = await axios.post(`${API_BASE_URL}/admin/login`, {
        username,
        password,
      });
  
      if (response.data.success) {
        const token = response.data.token;
        console.log('Response data:', response.data);

        if (token) {
          // Store the token in cookies
          Cookies.set('admin', token, { expires: 7, secure: true, sameSite: 'Strict' });
  
          // Navigate to the admin dashboard
          navigate('/admin/dashboard/registered-customer');
        } else {
          console.error("Token is missing in the response");
          alert("Login failed: No token provided by the server.");
        }
      } else {
        alert('Invalid username or password');
      }
    } catch (error) {
      console.error('Error logging in:', error.response?.data || error.message);
      alert(`Error logging in: ${error.response?.data?.message || error.message}`);
    } finally {
      setLoading(false);
    }
  };
  

  const handleForgotPassword = async () => {
    setLoading(true);
    try {
      await axios.post(`${API_BASE_URL}/admin/forgot-password`);

      const email = 'securecare@securenetcables.com';
      const localPart = email.split('@')[0];
      const maskedLocalPart =
        localPart.substring(0, 2) + '*****' + localPart.substring(localPart.length - 2);
      const maskedEmail = `${maskedLocalPart}@${email.split('@')[1]}`;

      setForgotPasswordMessage(`${maskedEmail} - Password reset link sent successfully.`);
      setShowModal(true); // Show modal with the message
    } catch (error) {
      console.error('Error sending password reset email:', error);
      alert('Failed to send reset email');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="flex flex-col items-center justify-center min-h-screen bg-[#FAF9FF]">
    {loading && <LoadingScreen />}
  
    {!loading && (
      <div className="flex bg-white shadow-lg overflow-hidden w-10/12 max-w-4xl rounded-2xl">
        <div className="flex justify-center items-center w-1/2 bg-white overflow-hidden rounded-s-2xl">
          <img src="/auth-page-images/Admin-login.svg" alt="Admin Illustration" className="w-full h-full object-cover" />
        </div>
  
        <div className="w-1/2 p-8 mt-8 rounded-e-2xl">
          <div className="mb-6 flex justify-center">
            <img src="/auth-page-images/securent 1.svg" alt="Logo" className="mx-auto mb-6 h-8" />
          </div>
  
          <form onSubmit={handleLogin} className="pt-4">
            <div className="mb-6 relative">
              <input
                type="text"
                id="username"
                className="w-full p-2 pl-10 bg-[#E2EDFF80] rounded-md focus:outline-none focus:ring-2 focus:ring-[#1C50A3] text-lg font-semibold text-[#1C50A3] placeholder:text-[#1C50A3]"
                value={username}
                onChange={(e) => setUsername(e.target.value)}
                placeholder="Username"
                autoComplete="username"
                required
              />
              <span className="absolute inset-y-0 left-0 pl-3 flex items-center text-[#1C50A3]">
                <FontAwesomeIcon icon={faUser} />
              </span>
            </div>
  
            <div className="mb-4 relative">
              <input
                type={showPassword ? 'text' : 'password'}
                id="password"
                className="w-full p-2 pl-10 bg-[#E2EDFF80] rounded-md focus:outline-none focus:ring-2 focus:ring-[#1C50A3] text-lg font-semibold text-[#1C50A3] placeholder:text-[#1C50A3]"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                placeholder="Password"
                autoComplete="current-password"
                required
              />
              <span className="absolute inset-y-0 left-0 pl-3 flex items-center text-[#1C50A3]">
                <FontAwesomeIcon icon={faLock} />
              </span>
              <span
                className="absolute inset-y-0 right-0 pr-4 mt-1 flex items-center cursor-pointer text-[#1C50A3]"
                onClick={togglePasswordVisibility}
              >
                <FontAwesomeIcon icon={showPassword ? faEyeSlash : faEye} />
              </span>
            </div>
  
            <button
              type="submit"
              className="w-full font-semibold px-4 py-2 text-white bg-[#1C50A3] rounded-md hover:bg-[#163d7e]"
            >
              Login
            </button>
          </form>
  
          <div className="mt-4 text-end">
            <button onClick={handleForgotPassword} className="text-[#353535] hover:underline">
              Forgot Password?
            </button>
          </div>
        </div>
      </div>
    )}
  
    {showModal && (
      <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50" onClick={() => setShowModal(false)}>
        <div className="bg-white p-6 rounded-lg shadow-lg max-w-md w-full flex flex-col items-center" onClick={(e) => e.stopPropagation()}>
          <img src={nemessage} alt="Success" className="w-[160px] h-[160px] mb-4" />
          <h2 className="text-lg font-bold text-[#353535] mb-4 text-center">Check Email</h2>
          <p className="text-green-600 text-center">{forgotPasswordMessage}</p>
        </div>
      </div>
    )}
  
    {/* Developed by Text */}
    <footer className="mt-4 text-center text-gray-600 text-sm">
  <p>© 2025 Securenet India. All Rights Reserved.</p>
  <p>
    Developed by{" "}
    <a
      href="https://creativestudio24.in"
      target="_blank"
      rel="noopener noreferrer"
      className="hover:underline"
    >
      Creative Studio 24
    </a>
  </p>
</footer>

  </div>
  
  );
};

export default AdminLogin;
